import { Fragment, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { toast } from 'react-toastify';
import { CommonReligiousCultsCrumbs } from 'civil-status/constants/place';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import FormPlace from 'civil-status/components/place/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { PlaceForm } from 'civil-status/view-models/place';
import { transformRequest, transformResponse } from 'civil-status/utils/place';
import { MunicipalityValueDomainType } from 'shell/models/value-domain-type';
import { DomainType } from 'civil-status/constants/domain';

const ReligiousCultsEditPage = (): React.ReactElement => {
  const params = useParams();

  const [religiousCultsData] = useHttpFetch<HttpResponse<MunicipalityValueDomainType>, PlaceForm>(
    `${__ACT_API_URL__}/valori-dominio-atti/${DomainType.ReligiousCults}/${params.id}`,
    {
      onBootstrap: true,
      options: {
        method: 'get',
        loading: true,
        errorCatching: true,
      },
      transformer: transformResponse,
    }
  );

  const values = religiousCultsData.data as PlaceForm;

  const editReligiousCults = useHttpClient(`${__ACT_API_URL__}/valori-dominio-atti/update`, {
    options: {
      method: 'PUT',
      loading: true,
      errorCatching: true,
    },
  });

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues?: PlaceForm) => {
      const data = transformRequest(formValues, DomainType.ReligiousCults);
      (
        editReligiousCults({
          data,
        }) as ResponsePromise<void>
      ).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/stato-civile/culti-religiosi');
      });
    },
    [editReligiousCults, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonReligiousCultsCrumbs, { name: 'Modifica culto religioso' }]} />
      {religiousCultsData.isLoading ||
      religiousCultsData.pristine ||
      religiousCultsData.error ? undefined : (
        <FormPlace
          title="Modifica culto religioso"
          onSave={onSubmit}
          initialValues={values}
          isEdit
          isReligiousCults
        />
      )}
    </Fragment>
  );
};

ReligiousCultsEditPage.displayName = 'Religious Cults edit page component';

export default ReligiousCultsEditPage;
